/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getProfile = /* GraphQL */ `
  query GetProfile($id: ID!) {
    getProfile(id: $id) {
      id
      userID
      username
      bio
      privacy
      _version
      _deleted
      _lastChangedAt
      createdOn
      updatedOn
      owner
      posts {
        items {
          id
          profileID
          title
          teaser
          postedAt
          location
          lat
          lng
          privacy
          _version
          _deleted
          _lastChangedAt
          createdOn
          updatedOn
          owner
        }
        nextToken
        startedAt
      }
    }
  }
`;
export const listProfiles = /* GraphQL */ `
  query ListProfiles(
    $filter: ModelProfileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProfiles(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userID
        username
        bio
        privacy
        _version
        _deleted
        _lastChangedAt
        createdOn
        updatedOn
        owner
        posts {
          nextToken
          startedAt
        }
      }
      nextToken
      startedAt
    }
  }
`;
export const syncProfiles = /* GraphQL */ `
  query SyncProfiles(
    $filter: ModelProfileFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncProfiles(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        userID
        username
        bio
        privacy
        _version
        _deleted
        _lastChangedAt
        createdOn
        updatedOn
        owner
        posts {
          nextToken
          startedAt
        }
      }
      nextToken
      startedAt
    }
  }
`;
export const getPost = /* GraphQL */ `
  query GetPost($id: ID!) {
    getPost(id: $id) {
      id
      profileID
      title
      teaser
      postedAt
      location
      lat
      lng
      privacy
      _version
      _deleted
      _lastChangedAt
      createdOn
      updatedOn
      owner
      contents {
        items {
          id
          postID
          body
          location
          lat
          lng
          _version
          _deleted
          _lastChangedAt
          createdOn
          updatedOn
          owner
        }
        nextToken
        startedAt
      }
      comments {
        items {
          id
          postID
          content
          _version
          _deleted
          _lastChangedAt
          createdOn
          updatedOn
          owner
        }
        nextToken
        startedAt
      }
    }
  }
`;
export const listPosts = /* GraphQL */ `
  query ListPosts(
    $filter: ModelPostFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPosts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        profileID
        title
        teaser
        postedAt
        location
        lat
        lng
        privacy
        _version
        _deleted
        _lastChangedAt
        createdOn
        updatedOn
        owner
        contents {
          nextToken
          startedAt
        }
        comments {
          nextToken
          startedAt
        }
      }
      nextToken
      startedAt
    }
  }
`;
export const syncPosts = /* GraphQL */ `
  query SyncPosts(
    $filter: ModelPostFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncPosts(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        profileID
        title
        teaser
        postedAt
        location
        lat
        lng
        privacy
        _version
        _deleted
        _lastChangedAt
        createdOn
        updatedOn
        owner
        contents {
          nextToken
          startedAt
        }
        comments {
          nextToken
          startedAt
        }
      }
      nextToken
      startedAt
    }
  }
`;
export const getContent = /* GraphQL */ `
  query GetContent($id: ID!) {
    getContent(id: $id) {
      id
      postID
      body
      location
      lat
      lng
      _version
      _deleted
      _lastChangedAt
      createdOn
      updatedOn
      owner
      media {
        items {
          id
          contentID
          key
          contentType
          caption
          meta
          lat
          lng
          _version
          _deleted
          _lastChangedAt
          createdOn
          updatedOn
          owner
        }
        nextToken
        startedAt
      }
    }
  }
`;
export const listContents = /* GraphQL */ `
  query ListContents(
    $filter: ModelContentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listContents(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        postID
        body
        location
        lat
        lng
        _version
        _deleted
        _lastChangedAt
        createdOn
        updatedOn
        owner
        media {
          nextToken
          startedAt
        }
      }
      nextToken
      startedAt
    }
  }
`;
export const syncContents = /* GraphQL */ `
  query SyncContents(
    $filter: ModelContentFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncContents(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        postID
        body
        location
        lat
        lng
        _version
        _deleted
        _lastChangedAt
        createdOn
        updatedOn
        owner
        media {
          nextToken
          startedAt
        }
      }
      nextToken
      startedAt
    }
  }
`;
export const getMedia = /* GraphQL */ `
  query GetMedia($id: ID!) {
    getMedia(id: $id) {
      id
      contentID
      key
      contentType
      caption
      meta
      lat
      lng
      _version
      _deleted
      _lastChangedAt
      createdOn
      updatedOn
      owner
    }
  }
`;
export const listMedias = /* GraphQL */ `
  query ListMedias(
    $filter: ModelMediaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMedias(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        contentID
        key
        contentType
        caption
        meta
        lat
        lng
        _version
        _deleted
        _lastChangedAt
        createdOn
        updatedOn
        owner
      }
      nextToken
      startedAt
    }
  }
`;
export const syncMedia = /* GraphQL */ `
  query SyncMedia(
    $filter: ModelMediaFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncMedia(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        contentID
        key
        contentType
        caption
        meta
        lat
        lng
        _version
        _deleted
        _lastChangedAt
        createdOn
        updatedOn
        owner
      }
      nextToken
      startedAt
    }
  }
`;
export const getComment = /* GraphQL */ `
  query GetComment($id: ID!) {
    getComment(id: $id) {
      id
      postID
      content
      _version
      _deleted
      _lastChangedAt
      createdOn
      updatedOn
      owner
    }
  }
`;
export const listComments = /* GraphQL */ `
  query ListComments(
    $filter: ModelCommentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listComments(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        postID
        content
        _version
        _deleted
        _lastChangedAt
        createdOn
        updatedOn
        owner
      }
      nextToken
      startedAt
    }
  }
`;
export const syncComments = /* GraphQL */ `
  query SyncComments(
    $filter: ModelCommentFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncComments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        postID
        content
        _version
        _deleted
        _lastChangedAt
        createdOn
        updatedOn
        owner
      }
      nextToken
      startedAt
    }
  }
`;
